import { z } from 'zod';

import i18n from '@/i18n';

export const UserCreateSchema = z.object({
    name: z.string(),
    street: z.string().min(2, i18n.global.t('Hetta er ein kravdur teigur.')),
    zip: z.string().min(2, i18n.global.t('Hetta er ein kravdur teigur.')),
    city: z.string().min(2, i18n.global.t('Hetta er ein kravdur teigur.')),
    country_code: z.string(),
    language: z.string(),
    email: z.string().email(i18n.global.t('Vinaliga skriva ein rættan teldubústað.')),
    terms_accepted: z.literal<boolean>(true),
    privacy_policy_accepted: z.literal<boolean>(true),
});
